import { ComponentProps } from 'react';
import BeatLoader from 'react-spinners/BeatLoader';

export type LoadingSpinnerProps = ComponentProps<typeof BeatLoader>;

const LoadingSpinner = (props: LoadingSpinnerProps) => (
  <BeatLoader size={10} color={'#fff'} {...props} />
);

export { LoadingSpinner };
